<div class="tw-relative tw-rounded-lg tw-shadow-tb">
  <div class="tw-p-5 tw-flex tw-flex-col md:tw-grid md:tw-grid-cols-[200px_3fr]">
    <!-- info user -->
    <div class="tw-flex tw-flex-col">
      <!-- product -->
      <span class="tw-font-bold tw-w-36-">{{review.username}}</span>
      <span>{{getProductByIdFn(review.product_id) | titlecase}}</span>
      <span *ngIf="review.product_id === 1 || review.product_id === 2">{{'semantic.comments.item.room' | translate: {room: review.room} }}</span>
      <span class="tw-w-28" [mhTooltip]="review.product_id === 1 || review.product_id === 2 ? ('semantic.comments.tables.tooltips.reply_date' | translate) : null" position="above">{{review.date | formatDate: language}}</span>
      <span *ngIf="review?.country_code !== 'XX' && review.product_id === 3">{{'countries.'+ review.country_code | translate}}</span>
    </div>
    <!-- review -->
    <div>
      <span class="tw-font-bold">{{review.title}}</span>
      <p class="tw-mt-5" [ngClass]="{'tw-mb-2': translatedTitle || translatedDescription}" [innerHTML]="isHighlighted ? (review.comment | highlight : highlightStartPosition : highlightEndPosition: highlightColor) : review.comment"></p>
      <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mt-2">
        <!-- Chips de temas con opción de eliminar -->
        <span
          *ngFor="let theme of review.themes; let i = index"
          class="tw-px-3 tw-py-1 tw-rounded-full tw-cursor-default tw-text-sm tw-relative tw-flex tw-items-center tw-gap-1 tw-transition-all"
          [mhTooltip]="theme.start_position === null ? ('semantic.comments.tables.tooltips.no_relation' | translate) : (!canDeleteTheme && hoveredThemeIndex === i ? ('semantic.comments.tables.tooltips.delete_no_permission' | translate) : null)"
          [width]="'tw-w-fit'"
          [ngClass]="{'tw-bg-red-200': theme.polarity === 'negative', 'tw-bg-promoters/20': theme.polarity === 'positive', 'hover:tw-bg-promoters/50': theme.polarity === 'positive', 'hover:tw-bg-red-400': theme.polarity === 'negative'}"
          (mouseover)="handleThemeHover(theme, i)"
          (mouseleave)="handleThemeLeave()">
          {{ theme.translates | translateObject }}
          <i 
            *ngIf="hoveredThemeIndex === i"
            class="fas fa-times tw-text-[10px] tw-ml-1 tw-transition-opacity"
            [ngClass]="{'tw-cursor-pointer hover:tw-text-detractors': canDeleteTheme, 'tw-cursor-not-allowed tw-opacity-50': !canDeleteTheme}"
            (click)="handleDeleteThemeClick(theme, i, $event)">
          </i>
        </span>
      </div>
      <ng-container *ngIf="translatedTitle || translatedDescription">
        <div class="tw-border"></div>
        <div class="tw-mt-2" >
          <span class="tw-font-bold">{{translatedTitle}}</span>
          <p class="tw-mt-5">{{translatedDescription}}</p>
        </div>
      </ng-container>
      <p class="tw-text-xs tw-text-[#979797] tw-mt-2 tw-italic tw-block md:tw-hidden">{{('semantic.comments.tables.actions.mobile_warning') | translate}}</p>
    </div>
  </div>
  <div class="tw-p-5 tw-grid tw-grid-cols-[200px_3fr] tw-relative">
    <div class="tw-flex tw-gap-3 tw-items-center" [ngClass]="{'!tw-items-start': !collapsed}">
      <ng-container *ngIf="positiveThemeCount !== 0 || negativeThemeCount !== 0">
        <div *ngIf="positiveThemeCount === 0" class="tw-flex tw-gap-2" [mhTooltip]="'semantic.comments.polarities_qty' | translate: {positive: positiveThemeCount, negative: negativeThemeCount}" [position]="'above'" [width]="'tw-w-fit'">
          <div class="tw-w-5 tw-h-5 tw-bg-detractors tw-rounded-full"></div>
          <div class="tw-text-sm">0% - {{ 'commons.imperfect' | translate }}</div>
        </div>
        <div *ngIf="negativeThemeCount === 0" class="tw-flex tw-gap-2" [mhTooltip]="'semantic.comments.polarities_qty' | translate: {positive: positiveThemeCount, negative: negativeThemeCount}" [position]="'above'" [width]="'tw-w-fit'">
          <div class="tw-w-5 tw-h-5 tw-bg-promoters tw-rounded-full"></div>
          <div class="tw-text-sm">100% - {{ 'commons.perfect' | translate }}</div>
        </div>
        <div *ngIf="positiveThemeCount > 0 && negativeThemeCount > 0" class="tw-flex" [mhTooltip]="'semantic.comments.polarities_qty' | translate: {positive: positiveThemeCount, negative: negativeThemeCount}" [position]="'above'" [width]="'tw-w-fit'">
          <div class="tw-w-2.5 tw-h-5 tw-bg-promoters tw-rounded-l-full"></div>
          <div class="tw-w-2.5 tw-h-5 tw-bg-detractors tw-rounded-r-full"></div>
          <div class="tw-text-sm tw-ml-2">{{ (positiveThemeCount/reviewToDisplay.themes.length) * 100 | number: '1.0-0' }}% - {{ 'commons.imperfect' | translate }}</div>
        </div>
      </ng-container>
    </div>

    <div [@heightExpand]="collapsed ? 'void' : '*'">
      <div class="tw-grid tw-grid-cols-2">
        <div class="tw-grid tw-grid-cols-2 tw-gap-y-1">
          <span class="tw-font-bold">{{'commons.theme' | translate}}</span>
          <span class="tw-font-bold">{{'commons.sentiment' | translate}}</span>
          <ng-container *ngFor="let theme of reviewToDisplay.themes; let index = index">
            <span class="tw-font-medium" mhFindTranslate [language]="language" [translates]="theme.translates" [keyTranlsate]="'text'"></span>
            <div class="tw-flex tw-gap-1.5">
              <i *ngIf="theme.polarity === 'positive'" class="fas fas fa-smile tw-text-promoters tw-mt-[2.5px]" [mhTooltip]="'semantic.comments.tables.tooltips.positive' | translate"></i>
              <i *ngIf="theme.polarity === 'negative'" class="fas fas fa-frown tw-text-detractors tw-mt-[2.5px]" [mhTooltip]="'semantic.comments.tables.tooltips.negative' | translate"></i>
              <button *ngIf="edit" type="button" class="focus:tw-outline-0 tw-text-main-text hover:tw-text-main-orange tw-transition-colors tw-ml-1 tw-underline tw-text-[11px]" (click)="handleUpdatePolarity(theme, index)" [mhTooltip]="'semantic.comments.tables.tooltips.edit' | translate">{{'commons.switch' | translate}}</button>
            </div>
          </ng-container>

        </div>
        <div class="tw-grid tw-grid-cols-2 tw-gap-y-1">
          <span class="tw-font-bold">{{'commons.areas' | translate}}</span>
          <span class="tw-font-bold">{{'commons.sentiment' | translate}}</span>
          <ng-container *ngFor="let area of areas">
            <span class="tw-font-medium" mhFindTranslate [language]="language" [translates]="area.area.translates" [keyTranlsate]="'text'">
            </span>
            <div class="tw-flex tw-gap-1.5">
              <div class="tw-flex tw-gap-2">
                <span class="tw-font-bold">{{area?.positive}}</span>
                <i class="fas fa-smile tw-text-promoters tw-mt-[2.5px]" [mhTooltip]="'semantic.comments.tables.tooltips.positive' | translate"></i>
              </div>
              &#8901;
              <div class="tw-flex tw-gap-2">
                <span class="tw-font-bold">{{area?.negative}}</span>
                <i class="fas fa-frown tw-text-detractors tw-mt-[2.5px]" [mhTooltip]="'semantic.comments.tables.tooltips.negative' | translate"></i>
              </div>
            </div>
          </ng-container>

        </div>

      </div>
    </div>
  </div>
  <div class="tw-absolute tw-right-5 tw-bottom-5 tw-flex tw-gap-5 tw-font-bold" [ngClass]="{'!tw-relative tw-ml-auto tw-mt-5 tw-w-fit': !collapsed}">
    <mh-core-lib-button 
      [text]="(review.product_id === 1 || review.product_id === 2 ? ('semantic.comments.tables.actions.see_survey') : ('semantic.comments.tables.actions.see_review')) | translate"
      [isSecondary]="true"
      [width]="'tw-w-fit'"
      [height]="36"
      [customClass]="'!tw-shadow-none'"
      [textClass]="'tw-font-normal'"
      (clicked)="handleSeeSurveyReviewLink(review.link)">
    </mh-core-lib-button>
    
    <mh-core-lib-button
      *ngIf="languageId !== review.language_code"
      [text]="'commons.translate' | translate | titlecase"
      [isSecondary]="true"
      [width]="'tw-w-fit'"
      [height]="36"
      [customClass]="'!tw-shadow-none'"
      [textClass]="'tw-font-normal'"
      (clicked)="handleTranslateComment()">
    </mh-core-lib-button>

    <mh-core-lib-actions-wrapper
        slug="semantic_comments_edit"
        *ngIf="!collapsed"
        >
        <mh-core-lib-button
          [text]="(edit ? 'forms.save' : 'commons.edit') | translate | titlecase"
          [isSecondary]="true"
          [width]="'tw-w-fit'"
          [height]="36"
          [customClass]="'!tw-shadow-none'"
          [textClass]="'tw-font-normal'"
          [mhTooltip]="'semantic.comments.tables.tooltips.edit' | translate"
          (clicked)="toggleEdit()">
        </mh-core-lib-button>
    </mh-core-lib-actions-wrapper>

    <mh-core-lib-button
      *ngIf="negativeThemeCount > 0 || positiveThemeCount > 0"
      [text]="(!collapsed ? 'semantic.comments.tables.actions.hide_details' : 'commons.see_detail') | translate | titlecase"
      [isSecondary]="true"
      [width]="'tw-w-fit'"
      [height]="36"
      [customClass]="'!tw-shadow-none'"
      [textClass]="'tw-font-normal'"
      (clicked)="toggleDetails()">
    </mh-core-lib-button>
  </div>
</div>
